import { render, staticRenderFns } from "./bindWeChatProfitSharing.vue?vue&type=template&id=5772adf2&scoped=true&"
import script from "./bindWeChatProfitSharing.vue?vue&type=script&lang=js&"
export * from "./bindWeChatProfitSharing.vue?vue&type=script&lang=js&"
import style0 from "./bindWeChatProfitSharing.vue?vue&type=style&index=0&id=5772adf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772adf2",
  null
  
)

export default component.exports